var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',{attrs:{"value":_vm.value,"optionsPromise":_vm.salesRateOptionsPromise,"placeholder":_vm.placeholder,"field":_vm.field,"note":_vm.note},on:{"input":_vm.updateRate}})}
var staticRenderFns = []

export { render, staticRenderFns }